<template>
  <div class="doc-container">
    <div class="doc-tab">
      <!-- 选择模块 -->
      <div class="choose-box flex-between">
        <!-- 选择语言 -->
        <div class="flex-align-center">
          <language-group
            @change="changeLanguage"
            ref="languageRef"
            type="doc"
          ></language-group>
        </div>
        <div class="flex-align-center">
          <div
            class="flex-center"
            v-if="
              !flag && settingDetail?.native_engine_recommend_hidden !== 'true'
            "
          >
            <div
              class="flex-center margin-r-10"
              v-if="recommendMtList.length === 0"
            >
              <img
                src="../../../images/ai-img.png"
                alt=""
                width="16"
                height="16"
              />
              <span class="color-666 font-size-14 padding-l-6">
                AI将为您智能推荐引擎
              </span>
            </div>
            <div class="flex-center margin-r-10" v-else>
              <img
                src="../../../images/ai-img.png"
                alt=""
                width="16"
                height="16"
              />
              <span class="color-666 font-size-14 padding-l-6 padding-r-10">
                AI推荐引擎：
              </span>
              <div class="recommend-res flex-align-center">
                <div
                  v-for="(item, key) in recommendMtList"
                  :key="key"
                  :class="[
                    'mt-item',
                    'cursor-pointer',
                    twinslatorId == item.twinslatorId ? 'mt-item-active' : '',
                  ]"
                  @click="chooseMt(item, 'recommend')"
                >
                  <div>
                    <div class="flex-align-center">
                      <svg aria-hidden="true" class="icon">
                        <use :xlink:href="'#' + item.iconName"></use>
                      </svg>
                      <span
                        class="padding-l-8 height-16"
                        :title="item.twinslatorName"
                      >
                        {{ item.twinslatorName }}
                      </span>
                    </div>
                    <div class="mt-price">{{ item.price }}译力/千字</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <a-dropdown
            :trigger="['click']"
            placement="bottomRight"
            v-model:visible="visible"
          >
            <div
              class="choose-mt-box cursor-pointer flex-center"
              @click.prevent
              v-if="chooseTwinslatorObj?.twinslatorId"
            >
              <div>
                <div class="flex-center">
                  <svg aria-hidden="true" class="icon">
                    <use :xlink:href="'#' + chooseTwinslatorObj.iconName"></use>
                  </svg>
                  <span
                    style="height: 16px"
                    class="padding-l-8 padding-r-5 font-size-12"
                    :title="chooseTwinslatorObj.twinslatorName"
                  >
                    {{ chooseTwinslatorObj.twinslatorName }}
                  </span>
                </div>
                <div class="mt-price">
                  {{ chooseTwinslatorObj.price }}译力/千字
                </div>
              </div>
              <DownOutlined class="font-size-12 padding-l-4" />
            </div>

            <div
              class="choose-mt-default-box flex-center cursor-pointer"
              @click.prevent
              v-else
            >
              <div>
                <div class="text-center">
                  {{ recommendMtList.length > 0 ? '更多' : '全部引擎' }}
                  <DownOutlined class="font-size-12 padding-l-5" />
                </div>
              </div>
            </div>
            <template #overlay>
              <div class="all-mt-box" @click.prevent>
                <div class="mt-tabs display-flex">
                  <div
                    class="mt-tab flex-align-center margin-r-30"
                    :class="mtType == 1 && 'mt-tab-active'"
                    @click="mtType = 1"
                  >
                    垂直领域
                  </div>
                  <div
                    class="mt-tab flex-align-center margin-r-30"
                    :class="mtType == 2 && 'mt-tab-active'"
                    @click="mtType = 2"
                  >
                    通用领域
                  </div>
                  <div
                    class="mt-tab flex-align-center margin-r-30"
                    :class="mtType == 5 && 'mt-tab-active'"
                    @click="mtType = 5"
                  >
                    大模型
                  </div>
                  <div
                    v-if="myMt.length > 0"
                    class="mt-tab flex-align-center"
                    :class="mtType == 3 && 'mt-tab-active'"
                    @click="mtType = 3"
                  >
                    {{ enterpriseGlobalId == 'personal' ? '我的' : '企业' }}
                  </div>
                </div>
                <div class="mt-transn mt-common" v-if="mtType == 1">
                  <div class="display-flex">
                    <div
                      style="
                        width: 3px;
                        height: 12px;
                        background: var(--primary-color);
                        border-radius: 2px;
                        margin-top: 4px;
                      "
                    ></div>
                    <div
                      class="padding-l-10 padding-r-12 color-666 font-size-12"
                      style="line-height: 22px"
                    >
                      平台自研
                    </div>
                    <div class="display-flex flex-wrap flex-1">
                      <div
                        v-for="(item, key) in companyMt"
                        :key="key"
                        class="mt-choose-item margin-b-12 margin-r-15"
                        @click="chooseMt(item, 'all')"
                        v-if="companyMt.length > 0"
                      >
                        <div class="flex-center mt-icon-box">
                          <EngineTag :item="item"></EngineTag>
                          <svg aria-hidden="true" class="icon">
                            <use :xlink:href="'#' + item.iconName"></use>
                          </svg>
                        </div>
                        <div
                          class="text-center color-333 font-size-12 padding-t-6 white-1"
                          :title="item.twinslatorName"
                        >
                          {{ item.twinslatorName }}
                        </div>
                        <div class="mt-price">{{ item.price }}译力/千字</div>
                        <!-- 角标 -->
                        <div class="badge-box" v-if="item.iconType">
                          <img
                            src="../../../images/hot-mt-img.png"
                            v-if="item.iconType == 'HOT'"
                            alt=""
                          />
                          <img
                            src="../../../images/new-mt-img.png"
                            v-if="item.iconType == 'NEWEST'"
                            alt=""
                          />
                        </div>
                      </div>
                      <div v-else class="padding-l-20 font-size-12 color-999">
                        暂无数据
                      </div>
                    </div>
                  </div>
                  <div class="display-flex margin-t-12">
                    <div
                      style="
                        width: 3px;
                        height: 12px;
                        background: #00befa;
                        border-radius: 2px;
                        margin-top: 2px;
                      "
                    ></div>
                    <div
                      class="padding-l-10 padding-r-12 color-666 font-size-12"
                    >
                      联合共建
                    </div>
                    <div class="display-flex flex-wrap flex-1">
                      <div
                        v-for="(item, key) in userMt"
                        :key="key"
                        class="mt-choose-item margin-b-12 margin-r-15"
                        @click="chooseMt(item, 'all')"
                        v-if="userMt.length > 0"
                      >
                        <div class="flex-center mt-icon-box">
                          <EngineTag :item="item"></EngineTag>
                          <svg aria-hidden="true" class="icon">
                            <use :xlink:href="'#' + item.iconName"></use>
                          </svg>
                        </div>
                        <div
                          class="text-center color-333 font-size-12 padding-t-6 white-1"
                          :title="item.twinslatorName"
                        >
                          {{ item.twinslatorName }}
                        </div>
                        <div class="mt-price">{{ item.price }}译力/千字</div>
                      </div>
                      <div v-else class="padding-l-20 font-size-12 color-999">
                        暂无数据
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-general mt-common" v-else-if="mtType == 2">
                  <div class="display-flex flex-wrap">
                    <div
                      v-for="(item, key) in generalMt"
                      :key="key"
                      class="mt-choose-item margin-b-12 margin-r-12"
                      @click="chooseMt(item, 'all')"
                      v-if="generalMt.length > 0"
                    >
                      <div class="flex-center mt-icon-box">
                        <EngineTag :item="item"></EngineTag>
                        <svg aria-hidden="true" class="icon">
                          <use :xlink:href="'#' + item.iconName"></use>
                        </svg>
                      </div>
                      <div
                        class="text-center color-333 font-size-12 padding-t-6 white-1"
                      >
                        {{ item.twinslatorName }}
                      </div>
                      <div class="mt-price">{{ item.price }}译力/千字</div>
                    </div>
                    <div v-else class="padding-l-20 font-size-12 color-999">
                      暂无数据
                    </div>
                  </div>
                </div>
                <div class="mt-general mt-common" v-else-if="mtType == 3">
                  <div class="display-flex flex-wrap">
                    <div
                      v-for="(item, key) in myMt"
                      :key="key"
                      class="mt-choose-item margin-b-12 margin-r-12"
                      @click="chooseMt(item, 'all')"
                      v-if="myMt.length > 0"
                    >
                      <div class="flex-center mt-icon-box">
                        <EngineTag :item="item"></EngineTag>
                        <svg aria-hidden="true" class="icon">
                          <use :xlink:href="'#' + item.iconName"></use>
                        </svg>
                      </div>
                      <div
                        class="text-center color-333 font-size-12 padding-t-6 white-1"
                      >
                        {{ item.twinslatorName }}
                      </div>
                      <div class="mt-price">{{ item.price }}译力/千字</div>
                    </div>
                    <div v-else class="padding-l-20 font-size-12 color-999">
                      暂无数据
                    </div>
                  </div>
                </div>
                <div class="mt-general mt-common" v-else-if="mtType == 5">
                  <aiMtView
                    v-model:parentVisible="visible"
                    :list="aiMt"
                    @onChange="chooseMt"
                    @get-list="getAllMtList"
                  />
                </div>
              </div>
            </template>
          </a-dropdown>
        </div>
      </div>
      <!-- 翻译模块 -->
      <div class="translate-box">
        <div>
          <a-upload-dragger
            :accept="accept"
            name="file"
            multiple
            :showUploadList="false"
            :disabled="isPre"
            :customRequest="customRequest"
          >
            <!-- 未上传 -->
            <div v-if="fileList.length === 0" class="margin-t-26">
              <moreFormat />
              <div class="color-333 font-size-18 font-weight-400 margin-t-12">
                拖拽文档到此进行翻译
              </div>
              <p class="color-999 font-size-14 margin-b-12">
                单个文件≤{{ singleFileSize }}M
              </p>
              <div class="btn-box display-flex align-center justify-center">
                <a-button
                  size="large"
                  class="trans-btn margin-r-16"
                  @click="uploadClick($event)"
                >
                  上传文档
                </a-button>
                <a-button
                  size="large"
                  class="trans-btn"
                  @click.stop.prevent="uploadFolderClick($event)"
                >
                  上传文件夹
                </a-button>
              </div>
            </div>
            <!-- 上传完成 -->
            <div v-else class="margin-t-26">
              <div class="flex-center">
                <div class="margin-r-40">
                  <div class="color-333 font-size-14 font-weight-400">
                    拖拽文档到此进行翻译
                  </div>
                  <p class="color-999 font-size-12">
                    单个文件≤{{ singleFileSize }}M
                  </p>
                </div>
                <moreFormat />
                <div class="btn-box margin-l-40">
                  <div class="margin-b-8">
                    <a-button class="trans-btn" @click="uploadClick($event)">
                      上传文档
                    </a-button>
                  </div>
                  <div>
                    <a-button
                      class="trans-btn"
                      @click.stop.prevent="uploadFolderClick($event)"
                    >
                      上传文件夹
                    </a-button>
                  </div>
                </div>
              </div>
              <div class="success-list-box">
                <div
                  v-for="(item, index) in fileList"
                  :key="index"
                  class="list-box"
                >
                  <div class="display-flex justify-between align-center">
                    <div
                      class="left-box display-flex justify-start align-center"
                    >
                      <fileIcon size="24" :name="item.name"></fileIcon>
                      <div
                        class="display-flex justify-center align-center white-1"
                      >
                        <span class="white-1" style="max-width: 500px">
                          <a-tooltip placement="topLeft" :title="item.name">
                            {{ item.name }}
                          </a-tooltip>
                        </span>
                        <span
                          v-if="item.isRepeat"
                          class="color-f55c3f margin-l-8"
                        >
                          文件重复
                        </span>
                        <span
                          v-if="formatCheck(item.name)"
                          class="color-f55c3f margin-l-8"
                        >
                          不支持的文件格式
                        </span>
                      </div>
                    </div>
                    <div class="right-box display-flex align-center">
                      <span
                        v-if="item.size / 1024 / 1024 > 1"
                        class="text-left color-999"
                        style="flex: 0 0 100px"
                      >
                        {{ (item.size / 1024 / 1024).toFixed(2) }}M
                      </span>
                      <span
                        v-else
                        class="text-left color-999"
                        style="flex: 0 0 100px"
                      >
                        {{ (item.size / 1024).toFixed(2) }}KB
                      </span>
                      <div
                        class="progress-box margin-r-20 display-flex align-center"
                      >
                        <span
                          v-if="
                            item.fileId &&
                            item.isZip &&
                            !item.zipSuccess &&
                            !item.message &&
                            !item.isUploading
                          "
                          class="margin-r-8"
                        >
                          解压中
                          <a-spin size="small" />
                        </span>
                        <span
                          v-if="
                            item.fileId &&
                            item.isZip &&
                            !item.zipSuccess &&
                            item.message &&
                            !item.isUploading
                          "
                          class="color-f55c3f margin-r-8"
                        >
                          {{ item.message || '解压失败' }}
                        </span>
                        <span v-if="item.isUploading" class="margin-r-8">
                          上传中
                          <a-spin size="small" />
                        </span>
                        <span
                          v-if="!item.isUploading && !item.isZip"
                          class="margin-r-8"
                        >
                          上传完成
                        </span>
                        <!-- <a-progress class="progress-bar" :percent="30" size="small" /> -->
                      </div>
                      <div
                        v-if="!item.isZip"
                        class="tj-box margin-r-20 display-flex align-center"
                      >
                        <span v-if="item.status === 0" class="margin-r-8">
                          获取字数中
                          <a-spin size="small" />
                        </span>
                        <span v-else-if="item.status === 1" class="margin-r-8">
                          {{ item.wordCount }}
                        </span>
                        <span
                          v-else-if="item.status === -1"
                          class="color-f55c3f margin-r-8"
                        >
                          {{ item.message || '统计失败' }}
                        </span>
                      </div>
                      <div
                        v-else
                        class="tj-box margin-r-20 display-flex align-center"
                      ></div>
                      <a-tooltip
                        @click.stop.prevent="delFile(item, index)"
                        class="cursor-pointer"
                      >
                        <template #title>删除</template>
                        <CloseCircleFilled />
                      </a-tooltip>
                    </div>
                  </div>
                </div>
              </div>
              <div class="btn-box display-flex align-center justify-center">
                <a-button
                  type="primary"
                  size="large"
                  class="trans-btn"
                  :loading="loading"
                  @click.stop.prevent="startFunc"
                >
                  立即翻译
                </a-button>
              </div>
            </div>
            <div class="term-corpus-box flex-center margin-t-20">
              <div class="flex-center" @click.stop.native="() => {}">
                <div
                  v-if="
                    fileList.some((r) => r.name.toLowerCase().endsWith('.pdf'))
                  "
                  class="flex-center margin-r-20"
                >
                  pdf解析方式：
                  <a-select
                    v-model:value="parseMode"
                    class="select-box"
                    style="width: 250px"
                  >
                    <a-select-option :value="1">
                      导出译文为可编辑word
                    </a-select-option>
                    <a-select-option :value="2">
                      格式优先，译文为pdf
                    </a-select-option>
                  </a-select>
                </div>
                <div class="flex-center">
                  <a-checkbox v-model:checked="checked" class="font-size-14">
                    术语
                  </a-checkbox>
                  <div
                    class="choose-term flex-align-center"
                    v-if="checked"
                    @click.stop="showTermModal"
                  >
                    <div
                      class="color-bbb font-weight-400 font-size-14"
                      v-if="!defaultTerm?.library_name"
                    >
                      请选择术语库
                    </div>
                    <div
                      v-else
                      style="max-width: 150px"
                      class="white-1"
                      :title="defaultTerm?.library_name || ''"
                    >
                      {{ defaultTerm?.library_name }}
                    </div>
                    <DownOutlined class="down-icon" />
                  </div>
                </div>
                <div class="flex-center">
                  <a-checkbox
                    v-model:checked="corpusChecked"
                    class="font-size-14"
                  >
                    语料
                  </a-checkbox>
                  <div
                    class="choose-term flex-align-center"
                    v-if="corpusChecked"
                    @click.stop="showCorpusModal"
                  >
                    <div
                      class="color-bbb font-weight-400 font-size-14"
                      v-if="!defaultCorpus?.library_name"
                    >
                      请选择语料库
                    </div>
                    <div
                      v-else
                      style="max-width: 150px"
                      class="white-1"
                      :title="defaultCorpus?.library_name || ''"
                    >
                      {{ defaultCorpus?.library_name }}
                    </div>
                    <DownOutlined class="down-icon" />
                  </div>
                </div>
              </div>
            </div>
          </a-upload-dragger>
        </div>
      </div>
      <input
        id="fileinp"
        ref="fileinp"
        title=""
        type="file"
        webkitdirectory
        directory
        multiple
        class="p-a position-tl opacity-0 z-10 cursor-pointer display-none"
        @change="handleFileSelect"
      />
    </div>
    <!-- 翻译列表 -->
    <DocTranslationList ref="translationListRef" />

    <!-- 术语列表弹窗 -->
    <TermModal
      v-model:termVisible="termVisible"
      :termData="termData"
      :libId="defaultTerm.library_id"
      @updateDefaultTerm="updateDefaultTerm"
    />

    <calculateTextModal
      ref="calculateTextRef"
      :mtDetail="chooseTwinslatorObj"
      v-model:loading="loading"
    ></calculateTextModal>

    <!--语料库弹窗-->
    <CorpusModal
      v-model:corpusVisible="corpusVisible"
      :corpusData="corpusData"
      :libId="defaultCorpus.library_id"
      @updateDefaultCorpus="updateDefaultCorpus"
    ></CorpusModal>

    <a-modal
      title="提示"
      :visible="resetTipVisible"
      @ok="resetTiphandleOk"
      @cancel="resetTipVisible = false"
      centered
    >
      <div class="text-center">
        <img src="@/images/bigWarning.png" width="48" height="48" />
      </div>
      <div class="font-size-16 color-333 text-center margin-t-16">
        存在未提交翻译的文件，离开将清空文件列表，确认离开？
      </div>
      <div class="font-size-14 color-999 text-center margin-t-10">
        翻译记录中的文件将继续正常翻译
      </div>
    </a-modal>
  </div>
</template>

<script setup>
  import {
    ref,
    reactive,
    toRefs,
    onMounted,
    watch,
    onUnmounted,
    computed,
    onBeforeUnmount,
    nextTick,
  } from 'vue'
  import {
    UploadOutlined,
    DownOutlined,
    QuestionCircleOutlined,
    EditOutlined,
    CloseCircleFilled,
  } from '@ant-design/icons-vue'
  import { message } from 'ant-design-vue'
  import { useRoute, useRouter } from 'vue-router'
  import { useStore } from 'vuex'

  import {
    getDocCharCount,
    getDocCharCountByCache,
    queryDocMtCostByCharCount,
    createDocMtTask,
    getUploadTokenNew,
    uploadFileNew,
    enginesList,
    getRecommendTwinslators,
    getDocTranslateLib,
    fileDecompress,
    batchDocCharCountByCache,
  } from '@/http/api'
  import LanguageGroup from '../components/Language/LanguageGroup.vue'
  import MtPrice from './MtModal/Price.vue'
  import MtSuccess from './MtModal/Success.vue'
  import AddTerms from '../components/AddTerms.vue'
  import TermModal from './MtModal/TermModal.vue'
  import CorpusModal from './MtModal/CorpusModal.vue'
  import FileIcon from '@/views/experience/docTranslation/module/fileIcon.vue'
  import calculateTextModal from '@/components/Modal/calculateTextModal.vue'
  import aiMtView from '@/components/aiMt/index.vue'
  import DocTranslationList from '@/views/experience/docTranslationList/index.vue'
  import moreFormat from '../components/moreFormat.vue'

  const emit = defineEmits(['ok'])

  const loading = ref(false)
  const isPre = ref(false)
  const spinLoading = ref(false)
  const loadingOpacity = ref(false)
  const files = ref({})
  const accept = ref(
    '.doc,.docx,.docm,.xls,.xlsx,.xlsm,.ppt,.pptx,.pdf,.srt,.txt,.dxf,.dwg,.json,.properties,.yaml,.yml,.xml,.csv,.htm,.html,.sdlxliff,.mqxliff,.xliff,.dita,.rtf,.zip'
  )
  const translationListRef = ref(null)

  // const successVisible = ref(false)
  // const priceRef = ref(null);
  const calculateTextRef = ref(null)
  const store = useStore()
  const uploadSize = computed(() => {
    return (
      store.state.comm.userLevel?.privilege?.tw_batch_upload_file_total_size ||
      1024
    )
  })
  const uploadCount = computed(() => {
    return (
      store.state.comm.userLevel?.privilege?.tw_batch_upload_file_count || 100
    )
  })
  const singleFileSize = computed(() => {
    return store.state.comm.userLevel?.privilege?.project_single_file_size || 50
  })

  const permission = computed(
    () => store.state.comm.enterpriseGlobalObj?.permission || []
  )

  const router = useRouter()
  const route = useRoute()
  const query = route.query
  const flag = query?.type && query?.type == 'docTranslate'

  const enterpriseGlobalId = computed(() => store.state.comm.enterpriseGlobalId)
  const settingDetail = computed(() => store.state.comm.settingDetail)

  const state = reactive({
    twinslatorId: (flag && query?.twinslatorId) || null,
    docUrl: '',
    detailData: {},
    sourceLangId: (flag && query?.sourceLangId) || undefined,
    targetLangId: (flag && query?.targetLangId) || 2,
    industryId: '',
    wordCount: '',
    recommendMtList: [],
    mtList: [], // 所有引擎
    companyMt: [], // 公司自研
    userMt: [], // 用户共建
    generalMt: [], // 通用引擎
    myMt: [], // 我的引擎
    aiMt: [], // 大模型
    chooseTwinslatorObj: {},
    visible: false,
    textFileId: '',
    mtType: 1, // 1 垂直领域， 2 通用领域
    checked: true, //应用术语库选择
    corpusChecked: true, //应用语料库选择
    termData: [], //术语库数据
    corpusData: [], //语料库数据
    defaultTerm: {},
    defaultCorpus: {},
    termVisible: false,
    corpusVisible: false,
    parseMode: 1,
    getStyle: 1,
  })
  const {
    twinslatorId,
    docUrl,
    detailData,
    sourceLangId,
    targetLangId,
    industryId,
    wordCount,
    recommendMtList,
    mtList,
    companyMt,
    userMt,
    generalMt,
    myMt,
    aiMt,
    chooseTwinslatorObj,
    visible,
    textFileId,
    mtType,
    checked,
    corpusChecked,
    termData,
    corpusData,
    defaultTerm,
    defaultCorpus,
    termVisible,
    corpusVisible,
    parseMode,
    getStyle,
  } = toRefs(state)

  const languageRef = ref(null)
  const fileinp = ref(null)
  const resetTipVisible = ref(false)

  const _dbFile = sessionStorage.getItem('db_file')
  const dbFile = _dbFile ? JSON.parse(_dbFile) : ''
  if (dbFile) {
    files.value.fileName = dbFile.docName
    files.value.fileSize = dbFile.docSize
    files.value.fileId = dbFile.fileId
    state.docUrl = dbFile.docUrl
    state.textFileId = dbFile.textFileId
  }

  // 立即翻译
  const startFunc = async () => {
    if (settingDetail.value.disable_non_order_use_epower === 'true') {
      message.error('非订单项目禁止使用译力')
      return
    }
    if (!state.sourceLangId) {
      message.warning('请选择源语种')
      return
    }
    if (!state.targetLangId) {
      message.warning('请选择目标语种')
      return
    }
    if (!state.twinslatorId) {
      message.warning('请选择机翻引擎')
      return
    }
    if (fileList.value.length === 0) {
      message.warning('请上传文件')
      return
    }
    for (let i = 0; i < fileList.value.length; i++) {
      const item = fileList.value[i]
      if (!item.fileId || !item.isSuccess) {
        return message.warning('存在处理中的文件，请处理完成后再次点击')
      }
      if (item.fileId && item.isZip && !item.zipSuccess && !item.message) {
        return message.warning('存在处理中的文件，请处理完成后再次点击')
      }
      if (item.fileId && item.isZip && !item.zipSuccess && item.message) {
        return message.warning('存在解压失败的文件，请剔除后再次点击')
      }
      if (item.status === 0) {
        return message.warning('存在处理中的文件，请处理完成后再次点击')
      }
      if (item.status === -1) {
        return message.warning('存在统计失败的文件，请剔除后再次点击')
      }
      if (formatCheck(item.name)) {
        return message.warning('不支持的文件格式，请剔除后再次点击')
      }
      if (item.size > singleFileSize.value * 1024 * 1024) {
        return message.warning(
          `存在大于${singleFileSize.value}M文件，请剔除后再次点击`
        )
      }
    }
    if (fileList.value.length > uploadCount.value) {
      message.warning(
        `文件数量超出限制（最多${uploadCount.value}个），已自动截取前${uploadCount.value}个文件`
      )
      return
    }
    const allSize = fileList.value.reduce((acc, curr) => acc + curr.size, 0)
    if (allSize / 1024 / 1024 > uploadSize.value) {
      message.warning(`总文件大小超过${uploadSize.value}M，请剔除后再次点击`)
      return
    }

    loading.value = true
    try {
      let ids = []
      fileList.value.forEach((item) => {
        if (item.wordCount) {
          ids.push(item.fileId)
        }
      })
      const res = await queryDocMtCostByCharCount({
        twinslatorId: state.twinslatorId,
        fileId: ids.join(','),
        libraryId: state.checked ? state.defaultTerm?.library_id : '',
      })
      if (res) {
        const _data = res.data.data
        // state.pricevisible = true
        state.detailData = _data
        //初始化扣费
        calculateTextRef.value.init(
          state.detailData,
          () => {
            confirmOrder()
          },
          () => {
            loading.value = false
          }
        )
      } else {
        loading.value = false
      }
    } catch (error) {
      loading.value = false
    }
  }

  // 清除
  const removeFile = () => {
    state.textFileId = ''
    files.value = {}
    loading.value = false
    isPre.value = false
    loadingOpacity.value = false
    state.docUrl = ''
    spinLoading.value = false
    state.chooseTwinslatorObj = {}
    state.twinslatorId = ''
    state.recommendMtList = []
    state.sourceLangId = undefined
    languageRef.value.srcLanguage = undefined
    state.targetLangId = undefined
    languageRef.value.tarLanguage = undefined
    state.confidentialLevel = null
    state.defaultTerm = {}
    state.defaultCorpus = {}
    state.mtList = []
    isMtList.value = true
    sessionStorage.removeItem('db_file')
  }

  // 权限判断
  const checkTwinsmtUse = () => {
    return new Promise((resolve, reject) => {
      if (!permission.value.includes('tc.twinsmt.use')) {
        message.error('您在企业内暂无文档快翻权限，可联系管理员调整权限')
        reject()
      }
      resolve()
    })
  }
  const uploadClick = (e) => {
    checkTwinsmtUse()
      .then(() => {})
      .catch(() => {
        e.stopPropagation()
        e.preventDefault()
      })
  }
  const uploadFolderClick = (e) => {
    checkTwinsmtUse()
      .then(() => {
        fileinp.value.click()
      })
      .catch(() => {
        e.stopPropagation()
        e.preventDefault()
      })
  }

  // 确认下单
  const confirmOrder = () => {
    let ids = []
    fileList.value.forEach((item) => {
      ids.push(item.fileId)
    })
    let params = {
      fileIds: ids.join(','),
      industryId: state.industryId,
      sourceLangId: state.sourceLangId || '1',
      targetLangId: state.targetLangId || '2',
      mtId: state.twinslatorId,
      twinslatorId: state.twinslatorId,
      taskClassify: 10,
      termLibraryId: state.checked ? state.defaultTerm?.library_id : undefined,
      getStyle: state.getStyle,
      corpusLibraryId: state.corpusChecked
        ? state.defaultCorpus?.library_id
        : undefined,
    }
    const isPdf = fileList.value.some((r) =>
      r.name.toLowerCase().endsWith('.pdf')
    )
    if (isPdf) {
      params.parseMode = state.parseMode
    }
    createDocMtTask(params)
      .then((res) => {
        fileList.value = []
        isFirstCheck.value = false
        loading.value = false
        translationListRef?.value?.getList()
        removeFile()
      })
      .catch(() => {
        loading.value = false
      })
  }

  // 获取推荐引擎列表
  const getRecommendTwList = () => {
    if (!state.sourceLangId || !state.targetLangId) return
    if (settingDetail.value.native_engine_recommend_hidden === 'true') return
    getRecommendTwinslators({
      sourceLangId: state.sourceLangId,
      targetLangId: state.targetLangId,
      textFileId: state.textFileId,
    })
      .then((res) => {
        const data = res.data.data
        state.recommendMtList = data.list || []
      })
      .catch(() => {
        state.recommendMtList = []
      })
  }

  // 自动检测源语种
  const getDocCharCountByCacheFunc = async (fileId) => {
    try {
      const res = await getDocCharCountByCache({
        fileId,
      })
      const _data = res.data.data
      if (_data) {
        if (_data.errno == -1) {
          // message.error(_data.message || '文档解析失败')
          fileList.value.forEach((item) => {
            if (item.fileId === fileId) {
              item.status = -1
              item.wordCount = _data.wordCount
              item.message = '文档解析失败'
            }
          })
          removeFile()
          return
        }

        if (!state.sourceLangId) {
          state.sourceLangId = _data.sourceLangId
          languageRef.value.srcLanguage = state.sourceLangId
          if (state.sourceLangId == 1) {
            state.targetLangId = 2
            languageRef.value.tarLanguage = 2
          } else {
            state.targetLangId = 1
            languageRef.value.tarLanguage = 1
          }
        }

        if (_data.textFileId) {
          nextTick(() => {
            fileList.value.forEach((item) => {
              if (item.fileId === fileId) {
                item.status = 1
                item.wordCount = _data.wordCount
                item.message = ''
              }
            })
          })

          state.textFileId = _data.textFileId
          state.spinLoading = false
          getRecommendTwList(_data.textFileId)
          getAllMtList()
          return
        }
      }
      setTimeout(() => {
        getDocCharCountByCacheFunc(fileId)
      }, 1000)
    } catch (error) {
      state.spinLoading = false
    }
  }

  // 更改语言
  const changeLanguage = (v) => {
    state.targetLangId = v.tarLanguage
    state.sourceLangId = v.srcLanguage
    state.twinslatorId = null
    state.chooseTwinslatorObj = {}

    getRecommendTwList()
    getAllMtList()
  }

  // 获取全部引擎列表
  const getAllMtList = () => {
    return enginesList({
      sourceLangId: state.sourceLangId,
      targetLangId: state.targetLangId,
      twinslatorId: state.twinslatorId || undefined,
    }).then((res) => {
      const data = res.data.data
      state.mtList = data.list || []
      state.companyMt = state.mtList.filter((item) => item.type == 1)
      state.userMt = state.mtList.filter((item) => item.type == 2)
      state.generalMt = state.mtList.filter((item) => item.type == 3)
      state.myMt = state.mtList.filter((item) => item.type == 4)
      state.aiMt = state.mtList.filter((item) => item.type == 5)
      if (state.companyMt.length === 0 && state.userMt.length === 0) {
        state.mtType = 2
      }
      if (flag && state.twinslatorId) {
        const arr = state.mtList.filter(
          (item) => item.twinslatorId == state.twinslatorId
        )
        if (arr.length > 0) {
          state.chooseTwinslatorObj = arr[0]
        } else {
          state.chooseTwinslatorObj = {}
          state.twinslatorId = ''
        }
      }
    })
  }

  // 点击引擎
  const chooseMt = (item, type) => {
    if (type == 'all' && !item.support) return

    if (loading.value) {
      message.warning('上传文档中不可切换引擎')
      return
    }

    if (type == 'all') {
      state.chooseTwinslatorObj = item
    } else {
      state.chooseTwinslatorObj = {}
    }
    state.visible = false
    state.twinslatorId = item.twinslatorId
    // getTransnlate()
  }

  // 获取库列表
  const getDocMtLibListFunc = () => {
    getDocTranslateLib({
      libType: 1,
      sourceLanguageId: state.sourceLangId || 1,
      targetLanguageId: state.targetLangId,
      langReverse: true,
      includeShare: false,
      includeCollect: false,
    }).then((res) => {
      let myList = res.data.data.myLibs || []
      let eList = res.data.data.enterpriseLibs || []
      myList.forEach((item) => {
        item.libType = 1
      })
      eList.forEach((item) => {
        item.libType = 2
      })
      const list = [...myList, ...eList]
      state.termData = list
      // if (!state.defaultTerm.library_id) {
      //   state.defaultTerm = list.length > 0 && list[0];
      // }
      // console.log(state.defaultTerm);
    })
    // console.log(state.defaultTerm)
  }

  //获取语料库列表
  const getDocCorpusLibListFunc = () => {
    getDocTranslateLib({
      libType: 2,
      sourceLanguageId: state.sourceLangId || 1,
      targetLanguageId: state.targetLangId,
      langReverse: true,
      includeShare: false,
      includeCollect: false,
    }).then((res) => {
      let myList = res.data.data.myLibs || []
      let eList = res.data.data.enterpriseLibs || []
      myList.forEach((item) => {
        item.libType = 1
      })
      eList.forEach((item) => {
        item.libType = 2
      })
      const list = [...myList, ...eList]
      state.corpusData = list
      // if (!state.defaultCorpus.library_id) {
      //   state.defaultCorpus = list.length > 0 && list[0];
      // }
    })
  }

  const updateDefaultTerm = (libraryId) => {
    if (libraryId == -1) {
      state.defaultTerm = {}
      return
    }
    const list = state.termData.filter((item) => item.library_id === libraryId)
    state.defaultTerm = list.length > 0 ? list[0] : {}
  }

  const updateDefaultCorpus = (libraryId) => {
    if (libraryId == -1) {
      state.defaultCorpus = {}
      return
    }
    const list = state.corpusData.filter(
      (item) => item.library_id === libraryId
    )
    state.defaultCorpus = list.length > 0 ? list[0] : {}
  }

  //展示语料弹窗
  const showCorpusModal = () => {
    state.corpusVisible = true
    // getDocCorpusLibListFunc()
  }

  const showTermModal = () => {
    state.termVisible = true
  }

  const hasDuplicate = () => {
    const arr = fileList.value
    for (let i = 0; i < arr.length; i++) {
      for (let j = i + 1; j < arr.length; j++) {
        if (arr[i].name === arr[j].name) {
          arr[i].isRepeat = true
          arr[j].isRepeat = true
        }
      }
    }
  }
  // 文件夹上传
  const handleFileSelect = async (event) => {
    let fileValueCount = 0
    let pendingFolderUploadCount = 0
    const files = event.target.files
    for (let i = 0; i < files.length; i++) {
      fileValueCount++
      pendingFolderUploadCount++
      const file = files[i]
      if (file.size === 0) {
        pendingFolderUploadCount-- // 减少计数
        message.warning('当前文档为空文档，请重新上传')
        continue
      }
      if (file.size > singleFileSize.value * 1024 * 1024) {
        pendingFolderUploadCount-- // 减少计数
        message.warning(`存在大于${singleFileSize.value}M文件，系统已自动过滤`)
        continue
      }
      if (
        accept.value == '*' ||
        accept.value.includes(getFileExtension(file.name).toLowerCase())
      ) {
        //文件按名称排序
        // fileList.value.sort((a, b) => sortLikeWin(a, b))
        if (
          fileList.value.length + pendingFolderUploadCount >
          uploadCount.value
        ) {
          fileinp.value.value = null
          return message.warning(
            `文件数量超出限制（最多${uploadCount.value}个），已自动截取前${uploadCount.value}个文件`
          )
        }
        // 计算已存在的文件总大小
        const existingSize = fileList.value.reduce(
          (acc, curr) => acc + curr.size,
          0
        )
        // 加上当前文件大小
        const totalSize = existingSize + file.size
        if (totalSize / 1024 / 1024 > uploadSize.value) {
          pendingFolderUploadCount-- // 减少计数
          fileinp.value.value = null
          return message.warning(
            `总文件大小超过${uploadSize.value}M，请剔除后再次上传`
          )
        }
        startUploadFile(file)
        // 解决上传相同文件夹无法上传的问题
        if (fileValueCount === files.length) {
          fileinp.value.value = null
        }
      }
    }
  }
  // 上传
  const fileList = ref([])
  const pendingUploadCount = ref(0) // 新增计数器
  const customRequest = async ({ file }) => {
    if (!permission.value.includes('tc.twinsmt.use')) {
      message.error('您在企业内暂无文档快翻权限，可联系管理员调整权限')
      return
    }

    const acceptstr = accept.value.split(',')
    if (!acceptstr.includes(`.${getFileExtension(file.name).toLowerCase()}`)) {
      message.error('不支持的文件格式')
      return
    }
    if (file.size === 0) {
      message.warning('当前文档为空文档，请重新上传')
      return
    }
    if (file.size > singleFileSize.value * 1024 * 1024) {
      message.warning(`存在大于${singleFileSize.value}M文件，系统已自动过滤`)
      return
    }
    //超过选择个数限制，提示框
    if (fileList.value.length + pendingUploadCount.value >= uploadCount.value) {
      return message.warning(
        `文件数量超出限制（最多${uploadCount.value}个），已自动截取前${uploadCount.value}个文件`
      )
    }
    // 增加待上传计数
    pendingUploadCount.value++
    // 计算已存在的文件总大小
    const existingSize = fileList.value.reduce(
      (acc, curr) => acc + curr.size,
      0
    )
    // 加上当前文件大小
    const totalSize = existingSize + file.size
    if (totalSize / 1024 / 1024 > uploadSize.value) {
      pendingUploadCount.value-- // 减少计数
      message.warning(`总文件大小超过${uploadSize.value}M，请剔除后再次上传`)
      return
    }
    try {
      await startUploadFile(file)
    } finally {
      // 无论成功与否都减少计数
      pendingUploadCount.value--
    }
  }
  const zipFileIds = ref([])
  const startUploadFile = (file) => {
    return new Promise((resolve, reject) => {
      getUploadTokenNew({
        use: 'free_file_mt',
        fileName: file.name,
        fileSize: file.size,
      })
        .then((res) => {
          const _data = res.data
          const obj = {
            fileId: _data.fileId,
            name: file.name,
            size: file.size,
            uploadUrl: _data.uploadUrl,
            isUploading: true,
            isSuccess: false,
          }
          if (file.type.includes('zip')) {
            obj.isZip = true
          }
          fileList.value.unshift(obj)
          const _headers = _data.additionalHeader
          uploadFileNew(_data.uploadUrl, _headers, file)
            .then(() => {
              fileList.value.forEach((item) => {
                if (item.fileId === obj.fileId) {
                  item.isUploading = false
                  item.isSuccess = true
                  if (['zip'].includes(getFileExtension(item.name))) {
                    item.status = -1
                  } else {
                    item.status = 0
                  }
                }
              })
              if (file.type.includes('zip')) {
                zipFileIds.value.push(obj.fileId)
                clearTimeout(fileDecompressTimer.value)
                getFileDecompressFunc(obj)
              }

              nextTick(async () => {
                // 首次上传调用语种识别
                const flag = fileList.value.some((item) => !item.isZip)

                if (!isFirstCheck.value && flag) {
                  let params = {
                    fileId: _data.fileId,
                    fileName: file.name,
                    fileSize: file.size,
                  }
                  await firstCheckLanguageId(params)
                }
                hasDuplicate()
                batchDocCharCountByCacheFunc()
              })
              resolve()
            })
            .catch((err) => {
              spinLoading.value = false
              message.error('上传失败')
              const index = fileList.value.findIndex(
                (el) => el.fileId === obj.fileId
              )
              fileList.value.splice(index, 1)
              reject(err)
            })
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
  const isFirstCheck = ref(false)
  const notBatchFileId = ref('')
  const firstCheckLanguageId = async (params) => {
    notBatchFileId.value = params.fileId
    isFirstCheck.value = true
    await getDocCharCount(params)
      .then((res) => {
        getDocCharCountByCacheFunc(params.fileId)
      })
      .catch((err) => {
        spinLoading.value = false
      })
  }
  const fileDecompressTimer = ref(null)
  const getFileDecompressFunc = (file) => {
    if (zipFileIds.value.length === 0) {
      clearTimeout(fileDecompressTimer.value)
      return
    }
    const newFileList = JSON.parse(JSON.stringify(fileList.value))
    fileDecompress({ fileIds: zipFileIds.value.join(',') }).then((res) => {
      const list = res.data.data || []
      const firstItem = list.map((item) =>
        item.files.find((r) =>
          accept.value.includes(getFileExtension(r.fileName).toLowerCase())
        )
      )
      // 首次上传调用语种识别
      const flag = fileList.value.every((item) => item.isZip)
      if (!isFirstCheck.value && flag && firstItem[0]?.fileId) {
        let params = {
          fileId: firstItem[0].fileId,
          fileName: firstItem[0].fileName,
          fileSize: firstItem[0].fileSize,
        }
        firstCheckLanguageId(params)
      }
      list.forEach((item1) => {
        zipFileIds.value.forEach((item2, index) => {
          if (item1.fileId === item2) {
            if (item1.status === 'succeed') {
              const fileListIndex = fileList.value.findIndex(
                (el) => el.fileId === item1.fileId
              )
              clearTimeout(fileDecompressTimer.value)
              zipFileIds.value.splice(index, 1)
              nextTick(() => {
                newFileList[fileListIndex].zipSuccess = true
                newFileList[fileListIndex].name = file.name
                newFileList[fileListIndex].size = file.size
                newFileList[fileListIndex].isSuccess = true
                newFileList[fileListIndex].status = 0
                fileList.value = newFileList
                const newArr = []
                item1.files.forEach((el) => {
                  if (
                    accept.value.includes(
                      getFileExtension(el.fileName).toLowerCase()
                    )
                  ) {
                    const obj = {
                      fileId: el.fileId,
                      name: el.fileName,
                      size: el.fileSize,
                      fileUrl: el.fileUrl,
                      isZipChild: true,
                      isSuccess: true,
                      status: 0,
                    }
                    newArr.push(obj)
                  }
                })
                if (newArr.length === 0) {
                  message.warning('压缩包内无支持的格式，已清除')
                }
                // zip解压完成后去掉并插入zip所在位子 uploadCount.value
                if (fileList.value.length + newArr.length > uploadCount.value) {
                  newArr.splice(
                    uploadCount.value - fileList.value.length + 1,
                    newArr.length
                  )
                  message.warning(
                    `文件数量超出限制（最多${uploadCount.value}个），已自动截取前${uploadCount.value}个文件`
                  )
                }
                fileList.value.splice(fileListIndex + 1, 0, ...newArr)
                fileList.value.splice(fileListIndex, 1)
                hasDuplicate()
                batchDocCharCountByCacheFunc()
              })
            } else if (item1.status === 'failed') {
              const fileListIndex = fileList.value.findIndex(
                (el) => el.fileId === item1.fileId
              )
              clearTimeout(fileDecompressTimer.value)
              zipFileIds.value.splice(index, 1)
              nextTick(() => {
                newFileList[fileListIndex].zipSuccess = false
                newFileList[fileListIndex].message = item1.message
                newFileList[fileListIndex].name = file.name
                newFileList[fileListIndex].size = file.size
                newFileList[fileListIndex].status = -1
                fileList.value = newFileList
              })
            }
          }
        })
      })
      fileDecompressTimer.value = setTimeout(() => {
        getFileDecompressFunc(file)
      }, 3000)
    })
  }
  const delFile = (item, index) => {
    if (item.isZip) {
      const i = zipFileIds.value.findIndex((el) => el === item.fileId)
      if (i >= 0) {
        zipFileIds.value.splice(i, 1)
      }
    }
    fileList.value.splice(index, 1)
    fileList.value.forEach((el) => {
      el.isRepeat = false
    })
    if (fileList.value.length === 0) {
      state.chooseTwinslatorObj = {}
      state.twinslatorId = ''
      state.recommendMtList = []
      isFirstCheck.value = false
      state.sourceLangId = undefined
      languageRef.value.srcLanguage = undefined
      state.targetLangId = undefined
      languageRef.value.tarLanguage = undefined
    }
    nextTick(() => {
      hasDuplicate()
    })
  }
  const batchDocCharCountByCacheTimeout = ref(null)
  const batchDocCharCountByCacheFunc = () => {
    clearTimeout(batchDocCharCountByCacheTimeout.value)
    let ids = []
    fileList.value.forEach((item) => {
      if (
        !item.wordCount &&
        item.status === 0 &&
        item.fileId != notBatchFileId.value
      ) {
        ids.push({
          fileId: item.fileId,
          fileName: item.name,
          fileSize: item.size,
        })
      }
    })
    if (ids.length === 0) {
      clearTimeout(batchDocCharCountByCacheTimeout.value)
      return
    }
    batchDocCharCountByCache(ids).then((res) => {
      const data = res.data?.data?.fileWordCountList || []
      fileList.value.forEach((e1) => {
        data.forEach((e2) => {
          if (e1.fileId === e2.fileId && !e1.isZip) {
            e1.status = e2.status
            e1.wordCount = e2.wordCount
            e1.message = e2.message
          }
        })
      })
      batchDocCharCountByCacheTimeout.value = setTimeout(() => {
        batchDocCharCountByCacheFunc()
      }, 3000)
    })
  }

  onBeforeUnmount(() => {})

  onMounted(async () => {
    if (languageRef.value) {
      languageRef.value.srcLanguage = state.sourceLangId
      languageRef.value.tarLanguage = state.targetLangId
    }
    //赋值路由参数
    if (sessionStorage.getItem('parseMode')) {
      state.parseMode = parseInt(sessionStorage.getItem('parseMode'))
    }

    getAllMtList()
    getDocCorpusLibListFunc()
    // 监听 beforeunload 事件
    window.addEventListener('beforeunload', (event) => {
      if (fileList.value.length) {
        // 触发浏览器提示
        event.preventDefault() // 标准做法
        // 大部分现代浏览器会忽略 event.returnValue 的值，但为了兼容性还是设置一下
        event.returnValue = ''
      }
    })
  })

  onUnmounted(() => {
    sessionStorage.removeItem('db_file')
    sessionStorage.removeItem('parseMode')
    clearTimeout(batchDocCharCountByCacheTimeout.value)
  })

  watch(
    () => [state.sourceLangId, state.targetLangId],
    (n) => {
      //重置引擎选择
      state.chooseTwinslatorObj = {}
      getDocMtLibListFunc()
      getDocCorpusLibListFunc()
    }
  )
  let callbackFunc = () => {}
  let backFunc = () => {}
  const init = async (cbFunc, bkFunc) => {
    callbackFunc = cbFunc || null
    backFunc = typeof bkFunc === 'function' ? bkFunc : () => {}
    if (fileList.value.length > 0) {
      resetTipVisible.value = true
    } else {
      backFunc()
    }
  }
  const resetTiphandleOk = () => {
    callbackFunc()
  }
  const formatCheck = (name) => {
    if (!accept.value.includes(getFileExtension(name).toLowerCase())) {
      return true
    } else {
      return false
    }
  }
  const getFileExtension = (fileName) => {
    return fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length)
  }

  defineExpose({
    init,
  })
</script>
<style lang="scss" scoped>
  .color-ccc {
    color: #cccccc;
  }
  .mt-price {
    font-size: 12px;
    color: #bbb;
    text-align: center;
  }
  .mt-box :deep(.ant-modal-close-x) {
    width: 56px;
    height: 56px;
    line-height: 56px;
  }
  .doc-container {
    .doc-tab {
      background-color: #fff;
      border: 1px solid #f2f3f5;
      border-radius: 8px;
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.04);
      .choose-box {
        height: 58px;
        font-size: 14px;
        border-bottom: 1px solid #f2f3f5;
        margin: 0 20px;
      }
      .translate-box {
        padding: 20px 50px;
        :deep(.ant-upload-drag) {
          min-height: 272px;
          background: #fff;
          border: 1px dashed #f2f3f5;
          border-radius: 16px;
          .ant-upload-hint {
            font-size: 16px;
            color: #999;
          }
          .ant-upload {
            padding: 0;
          }
          &:hover {
            border: 1px solid #dcd3ff;
          }
        }
      }
      .padding-lr-300 {
        padding: 40px 300px;
      }
      .success-list-box {
        padding: 0 20px;
        max-height: 240px;
        overflow-y: auto;
        margin-bottom: 20px;
        .list-box {
          width: 100%;
          padding: 10px 16px;
          font-size: 14px;
          border-bottom: 1px solid #eeeeee;
          .left-box {
            width: 550px;
          }
          .right-box {
            width: 400px;
            .progress-box {
              flex: 0 0 150px;
              .progress-bar {
                width: 60px;
              }
            }
            .tj-box {
              flex: 0 0 100px;
            }
          }
        }
      }
      .success-box {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        // height: 320px;
        padding: 0 0 76px 0;
        border: 1px solid #dcd3ff;
        border-radius: 16px;
        :deep(.ant-upload-drag) {
          height: 106px;
          background: #fff;
          border: none;
          border-radius: 0;
          .ant-upload-hint {
            font-size: 16px;
            color: #999;
          }
          &:hover {
            border: none;
          }
        }
        .success-list-title {
          width: 1060px;
          border-top: 1px solid #eeeeee;
          margin-top: 24px;
          padding: 16px 0;
        }
      }

      .term-box {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 56px;
        //padding-left: 20px;
        background: #fafafc;
        border-radius: 0px 0px 16px 16px;
        border: 1px solid #f2f3f5;
        border-bottom: 0;
      }

      .term-corpus-box {
        width: 100%;
        height: 56px;
        //padding-left: 20px;
        background: #fafafc;
        border-radius: 0px 0px 16px 16px;
        border: 1px solid #f2f3f5;
        border-bottom: 0;
        display: flex;
      }

      .term-box,
      .term-corpus-box {
        .select-box {
          :deep(.ant-select-selector) {
            border-radius: 20px;
            border: 1px solid #edeeef;
            .ant-select-selection-item {
              text-align: left;
            }
          }
          :deep(.ant-select-arrow) {
            margin-top: -4px;
            color: #333;
            font-size: 10px;
          }
        }
      }

      .upload-default-img-box {
        width: 264px;
        height: 66px;
        margin: 0 auto 0;
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .btn-box {
        .trans-btn {
          width: 120px;
          padding: 0;
          // opacity: 0.3;
          opacity: 1;
        }
        .loading-opacity {
          opacity: 1;
        }
      }
    }
    .img-box {
      width: 1220px;
      margin: 0 auto 10px;
      margin-left: -10px;
      position: relative;
      cursor: pointer;
      .to-pe {
        position: absolute;
        left: 130px;
        bottom: 41px;
        width: 120px;
        height: 32px;
        background-color: transparent;
        cursor: pointer;
      }
    }
  }
  .file-name {
    .icon {
      width: 16px;
      height: 16px;
      vertical-align: middle;
      cursor: pointer;
    }
  }
  .icon {
    width: 16px;
    height: 16px;
    vertical-align: middle;
    flex-shrink: 0;
  }
  .recommend-res {
    height: 32px;
  }
  .mt-item {
    display: flex;
    align-items: center;
    padding: 4px 14px;
    color: #333;
    font-size: 13px;
    background: #fff;
    border-radius: 6px;
    margin-right: 8px;
    user-select: none;
    border: 1px solid #edeeef;
    &:hover {
      border: 1px solid #ded6ff;
    }
  }
  .mt-item-active {
    background: #f6faff;
    border: 2px solid var(--primary-color);
    &:hover {
      background: #f6faff;
      border: 2px solid var(--primary-color);
    }
  }
  .choose-mt-default-box {
    min-width: 104px;
    height: 47px;
    background: #fff;
    color: #333;
    font-size: 14px;
    border-radius: 6px;
    border: 1px solid #edeeef;
    &:hover {
      border: 1px solid var(--primary-color);
    }
  }
  .choose-mt-box {
    padding: 2px 14px;
    height: 47px;
    background: #fff;
    border-radius: 6px;
    border: 1px solid var(--primary-color);
  }
  .all-mt-box {
    width: 500px;
    height: 340px;
    background: #fff;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    border: 1px solid #f2f3f5;
    .mt-tabs {
      height: 48px;
      padding: 0 20px 0 30px;
      border-bottom: 1px solid #f2f3f5;
    }
    .mt-tab {
      color: #000;
      font-size: 14px;
      height: 100%;
      cursor: pointer;
    }
    .mt-tab-active {
      position: relative;
      font-weight: 600;
      &::after {
        position: absolute;
        right: 0;
        left: 0;
        bottom: 0;
        height: 2px;
        background: #333;
        content: '';
      }
    }
    .mt-common {
      padding: 20px 0 20px 20px;
      height: calc(100% - 48px);
      overflow-y: auto;
      &::-webkit-input-placeholder {
        font-size: 14px;
        color: #818385;
      }
      &::-webkit-scrollbar {
        width: 7px;
        background-color: rgba(0, 0, 0, 0);
      }
      &::-webkit-scrollbar-thumb {
        background: #bfbfbf;
        border-radius: 10px;
        width: 7px;
      }
    }
    .mt-choose-item {
      position: relative;
      //height: 90px;
      width: 74px;
      cursor: pointer;
      &:hover {
        .icon {
          width: 20px;
          height: 20px;
        }
      }
    }
    .mt-icon-box {
      width: 48px;
      height: 48px;
      background: #f5f5f5;
      border-radius: 50%;
      margin: 0 auto;
      position: relative;
      .icon {
        width: 20px;
        height: 20px;
        vertical-align: middle;
        cursor: pointer;
      }
      .add-tip-icon {
        padding: 2px;
        position: absolute;
        bottom: 0;
        right: -10px;
        &:hover {
          background: #eee;
          border-radius: 4px;
        }
      }
    }
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .file-type-box {
    width: 50px;
    height: 50px;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .choose-term {
    position: relative;
    width: 150px;
    height: 32px;
    padding-left: 16px;
    padding-right: 30px;
    background: #fff;
    border-radius: 20px;
    border: 1px solid #edeeef;
    margin-right: 12px;
    cursor: pointer;
    .down-icon {
      position: absolute;
      right: 16px;
      bottom: 4px;
      width: 16px;
      height: 16px;
      font-size: 10px;
      color: #333;
    }
  }
  .add-btn {
    height: 56px;
    cursor: pointer;
    svg {
      width: 16px;
      height: 16px;
    }
    span {
      height: 16px;
      line-height: 16px;
    }
  }
  .color-7a59ff {
    color: var(--primary-color);
  }
  .success-box {
    :deep(.ant-progress-text) {
      display: none;
    }
    :deep(.ant-progress-show-info .ant-progress-outer) {
      margin-right: 0;
      padding-right: 0;
    }
  }
  .badge-box {
    position: absolute;
    top: 0;
    right: 0;
    width: 24px;
    height: 12px;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  :deep(.ant-upload.ant-upload-drag .ant-upload-drag-container) {
    vertical-align: top;
  }
</style>
